import * as React from 'react'
import { breakpoint, styled } from '../../../../shared/styled-components'

interface IProps {
  segmentCount: number
  segment: number
}

export class SegmentedProgressBar extends React.Component<IProps> {
  private _renderSegments () {
    const segments = []
    const { segmentCount, segment } = this.props
    for (let i = 0; i < segmentCount; i++) {
      segments.push(<Segment active={segment === i} key={i} />)
    }
    return segments
  }

  render () {
    return (<Container>
      {this._renderSegments()}
    </Container>)
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15pt;
  order: -1;
  
  ${breakpoint('tablet')`
    position: absolute;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
    margin-bottom: 0; 
    order: unset;
  `}
`

const Segment = styled.div<{ active?: boolean }>`
  height: 4px;
  flex: 1;
  margin: 0 5px;
  background: ${props => props.active ? props.theme.primaryColor : 'white'};
  ${breakpoint('tablet')`
    width: 185px;
    margin: 0 13px;
  `}
`
